import { lazy } from 'react'

import { getEnv } from '@/libs/runtime-env/runtimeEnv'

const isTanStackQueryDevtools =
  getEnv('VITE_APP_TANSTACK_QUERY_DEVTOOLS') === 'true'

export const TanStackQueryDevtools = !isTanStackQueryDevtools
  ? () => null
  : lazy(() =>
      import('@tanstack/react-query-devtools').then((res) => ({
        default: res.ReactQueryDevtools,
      })),
    )
